import { render, staticRenderFns } from "./envioFacturacion.vue?vue&type=template&id=1748c0be"
import script from "./envioFacturacion.vue?vue&type=script&lang=js"
export * from "./envioFacturacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports